import { createSelector } from 'reselect'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'
import { areArraysEqual } from 'util/arrays'
import { isLimitsExceeded } from '../../util'
import { selectCombinedRemoteLocalUsage } from './selectCombinedRemoteLocalUsage'
import { selectFuturePricingIds } from '../selectFuturePricingIds'
import { selectFutureAvailableFeatures } from '../selectFutureAvailableFeatures'
import { selectCurrentPricingIds } from '../selectCurrentPricingIds'
import { selectIsPendingAnnualSwitch } from '../selectIsPendingAnnualSwitch'

export const selectShowBillingPlanUsageLimited = createSelector(
  selectCurrentUserIsAdminOrOwner,
  selectCombinedRemoteLocalUsage,
  selectFuturePricingIds,
  selectFutureAvailableFeatures,
  selectCurrentPricingIds,
  selectIsPendingAnnualSwitch,
  (
    isManager,
    billingUsage,
    futurePricingIds,
    futureAvailableFeatures,
    currentPricingIds,
    isPendingAnnualSwitch
  ) => {
    if (isPendingAnnualSwitch) return false

    return (
      futurePricingIds.length > 0 &&
      !areArraysEqual(currentPricingIds, futurePricingIds) &&
      isManager &&
      isLimitsExceeded(futureAvailableFeatures, billingUsage)
    )
  }
)
